import { render, staticRenderFns } from "./filter-author-dropdown.vue?vue&type=template&id=bb0883fe&scoped=true"
import script from "./filter-author-dropdown.vue?vue&type=script&lang=js"
export * from "./filter-author-dropdown.vue?vue&type=script&lang=js"
import style0 from "./filter-author-dropdown.vue?vue&type=style&index=0&id=bb0883fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0883fe",
  null
  
)

export default component.exports